import React from "react";
import Button from '@mui/material/Button';

function Report () {

return (

    <Button color="inherit">Report</Button>

);

}

export default Report;